import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { SidebarService } from '@nibtravel/shared/ui/components/sidebar';
import {
  fadeInOnEnterAnimation,
  fadeOutOnLeaveAnimation,
} from 'angular-animations';
import { Observable } from 'rxjs';

const defaultHeroCss = ['hero'];

@Component({
  selector: 'nibtravel-content-layout',
  templateUrl: 'content-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeInOnEnterAnimation(), fadeOutOnLeaveAnimation()],
})
export class ContentLayoutComponent implements OnInit {
  /**
   * The default behaviour merges the input classes with the default hero classes.
   * Should one need to completely override the hero classes, set overrideHeroCss to true.
   *
   * @default
   * ['hero']
   */
  @Input() heroContainerCss: string[] = [];

  /**
   * Works in conjunction with the heroContainerCss.
   * When the heroContainerCss is not provided,
   * it overrides the classes with a empty array.
   */
  @Input() overrideHeroCss = false;

  /**
   * Flag to enable a content layout with two columns
   * and a secondary sidebar. This configuration uses grid layout.
   *
   * @default false
   */
  @Input() twoColumns = false;

  showSidebarHost$!: Observable<boolean>;

  get heroCss(): string[] {
    return this.overrideHeroCss
      ? this.heroContainerCss
      : [...defaultHeroCss, ...this.heroContainerCss];
  }

  get mainContentCss(): string {
    return this.twoColumns ? 'two-col-container' : 'one-col-container';
  }

  constructor(private sidebarService: SidebarService) {}

  ngOnInit(): void {
    this.showSidebarHost$ = this.sidebarService.showSidebarHost();
  }
}
